import React from 'react'
import BaseButton from "../BaseButton"
import { PushGADataLayer } from '../../utils/helpers'

export default function MastheadContentUI({item}) {
  return (
    <div className="lg:w-[70%]">
      {item.heading && <h1>{item.heading}</h1>}
      {item.description && (
        <div className="mt-4 text-sm lg:text-base">
          {item.description}
        </div>
      )}
      {
        item.links?.map(link => {

          return (
            <BaseButton key={link.title} title={link.title} href={link.href} target={link.target} type={link.type} icon={link.icon} classes='lg:text-base px-5 py-2 lg:h-[50px] font-bold mt-4 w-full lg:w-auto lg:mr-5' iconClassName="ml-1.5 -mt-0.5 w-5 lg:w-6" btnClick={()=>{PushGADataLayer('Hero Banner Widget','Clicks',link.title)}}/>
          )
        })
      }
    </div>
  )
}
